import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import showDimmer from '@tk/utilities/tk.dimmer';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { findScrollableWrapper } from '@tk/utilities/tk.find.scrollable.wrapper';
import showProgressBar from '@tk/utilities/tk.progress';
import render from '@tk/utilities/tk.render';

export default class TKAsyncPaging extends TKCustomElementFactory {
    wrapper?: HTMLElement;
    jumpElements?: NodeListOf<HTMLButtonElement>;
    scrollableElement?: HTMLElement;

    constructor() {
        super();

        this.wrapper = this.querySelector('[data-tk-async-paging-wrapper]') || undefined;
        this.jumpElements = this.wrapper?.querySelectorAll('[data-tk-async-paging-jump]') || undefined;
    }

    connectedCallback(): void {
        if (!this.wrapper || this.jumpElements?.length === 0) return;

        this.registerClickListener();
        this.scrollToTop();
    }

    registerClickListener() {
        const action = this.jumpTo.bind(this);
        this.jumpElements?.forEach((element) => {
            this.pushListener({
                event: 'click',
                element,
                action,
            });
        });
    }

    jumpTo(event: Event) {
        const target = event.currentTarget as HTMLButtonElement;
        const url = target.getAttribute('data-tk-url');
        if (!url) return;
        this.scrollToTop();
        const progressBar = showProgressBar(this.scrollableElement || this);
        const dimmer = showDimmer(this.scrollableElement || this, {
            'background-color': 'rgba(0, 0, 0, 0.02)',
        });
        fetchRequest({
            requestURL: url,
            resolveHandler: this.handleResponse.bind(this),
        }).finally(() => {
            progressBar.remove();
            dimmer.remove();
        });
    }

    handleResponse(response: TKResponse) {
        if (!response || !response.success) return;
        const body = render(response.dataAsHtml, true);
        const wrapper = body.querySelector(this.tagName);
        if (!wrapper) return;
        this.outerHTML = wrapper.outerHTML;
    }

    scrollToTop() {
        this.scrollableElement = findScrollableWrapper(this);
        if (this.scrollableElement === document.body) {
            this.scrollableElement = this;
            document.scrollingElement?.scrollTo({ behavior: 'smooth', top: 0 });
        } else {
            this.scrollableElement?.scrollTo({ behavior: 'smooth', top: 0 });
        }
    }
}
